import React, { useEffect } from 'react';
import { Link, navigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import './index.css';
import { authSelector } from '../../../../../redux/auth/selector';
import appSlice from '../../../../../redux/app/index';
import { useNavigate  } from 'react-router-dom';

function Faq() {
    const { merchantNo } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { agxStoreName, agxMerchantNo, agxNewMerchantNo, user } = useSelector(authSelector);
    useEffect(() => {
        dispatch(appSlice.actions.changeUrlBanner("/store"));
    }, [dispatch]);

    return (
        <div className="wrapper-body">
            <div className="container">
                <div className="page-heading">
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/store" title="チョキペイ">チョキペイ</Link>
                        </li>
                        <li>
                            <Link to="/store-notification" title="その他">その他</Link>
                        </li>
                        <li>利用に関するFAQ {'>'} ストアの選択</li>
                    </ul>
                </div>
                <div className="row align-items-center">
                    <div className="menu-item col-sm-6 center-block pb-0">
                        <a id="paygate" href="https://choqi.co.jp/choqipay/faq/faq_list2.html?_gl=1*1im6h43*_ga*MTc3MTcwMzI0NC4xNjk0NDE2MTQz*_ga_CKW2PPLYTQ*MTcwNTk3Nzc1My4xOTkuMS4xNzA1OTc5NDMzLjAuMC4w*_ga_6SPDYLRMQY*MTcwNTk3Nzc1My4zNDcuMS4xNzA1OTc5NDMzLjAuMC4w*_ga_E11ER9VJEZ*MTcwNTk3Nzc1My4zNDcuMS4xNzA1OTc5NDMzLjAuMC4w*_ga_SK2YTSMLQC*MTcwNTk3Nzc1My42MjcuMS4xNzA1OTc5NDMzLjYwLjAuMA.." target="_blank">PAYGATE</a>
                        <div className='h-support'>
                        </div>
                    </div>
                    <div className="menu-item col-sm-6 center-block pb-0">
                        <a id="crepico" href="https://choqi.co.jp/choqipay/faq/faq_list12.html" target="_blank">CREPICO</a>
                        <div className='h-support'>
                            <div className='color-13AE9C mt-2'>※ CREPICO サポートサイトへのアクセスは下記を入力してください。</div>
                            <div className='d-flex color-13AE9C'>
                                <p className='w-25'>ユーザー名(ID)<span className='float-inline-end'>:</span></p>
                                <p>&nbsp;&nbsp;&nbsp;cp-user</p>
                            </div>
                            <div className='d-flex color-13AE9C'>
                                <p className='w-25'>パスワード<span className='float-inline-end'>:</span></p>
                                <p>&nbsp;&nbsp;&nbsp;cp-user1</p>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Faq;